
import React from 'react';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';

const TOOL_STYLE = mergeStyles({
    backgroundColor: 'rgba(128, 128, 128, 0.7)'
});

const getIcon = (name) => {
    return {
        iconName: name,
        style: {
            color: '#ffffff'
        }
    };
}

export default {
    TOOL_STYLE,
    getIcon
}
